import { render } from "./Sidentify.vue?vue&type=template&id=610a0650&scoped=true"
import script from "./Sidentify.vue?vue&type=script&lang=js"
export * from "./Sidentify.vue?vue&type=script&lang=js"

import "./Sidentify.vue?vue&type=style&index=0&id=610a0650&scoped=true&lang=css"

import exportComponent from "F:\\Work\\Lu\\_pz\\pzvtour\\pzvtour-userbackend\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-610a0650"]])

export default __exports__